const currentlyShownActions = {
    types: {
        UPDATE_CURRENTLY_SHOWN: 'UPDATE_CURRENTLY_SHOWN',
    },

    updateCurrentlyShown({ routeType, sectionId, questionId, scorableItem, route }) {
        return {
            type: this.types.UPDATE_CURRENTLY_SHOWN,
            routeType,
            sectionId,
            questionId,
            scorableItem,
            route,
        };
    },
};

export default currentlyShownActions;
